const resource = 'campaigns';

export default ($axios, isAdmin=false) => ({
	getCampaigns(params={}) {
		return $axios.get((isAdmin ? '/superAdmin' : '')+`/${resource}`, { params });
	},
	getCampaign(id, params={}) {
		return $axios.get(`/${resource}/${id}`, {params});
	},
	getCampaignAssignments(id, params={}) {
		return $axios.get(`/${resource}/${id}/getCampaignAssignmentsPopulated`, {params});
	},
	// PUT
	updateCampaign(campaignData) {
		return $axios.put(`/${resource}/${campaignData.id}`, campaignData)
	},
	updateCampaignAssignment(campaignId, assignments) {
		return $axios.put(`/${resource}/${campaignId}/updateCampaignAssignment`, assignments)
	},
	// POST
	createCampaign(campaignData) {
		return $axios.post(`/${resource}`, campaignData)
	},
});
